/* T FOR ALL — header: "SLUITEN" button inside the mega menu closes its <details>
   via Dawn's own summary toggle, so header-menu state stays in sync. */
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-tfa-mega-close]');
  if (!button) return;
  var details = button.closest('details[open]');
  var summary = details && details.querySelector('summary');
  if (summary) summary.click();
});

/* Logo always exactly in the centre (desktop). The grid gives menu and icons equal columns,
   but the right side (search, Mile Height Club, Log in, Wishlist, Cart, EN · NL) is longer
   than the room Figma's 130px side margins leave, and longer in Dutch ("Winkelmand (0)").
   The layout depends only on the screen width, so it is identical in every language and
   nothing moves when switching (widths measured on the Dutch header, the longest):
     >= 1460px  text labels, side margin (width - 1410) / 2, at most Figma's 8.6vw
     1238-1459  icons instead of Log in / Wishlist / Cart, margin (width - 1190) / 2
     990-1237   icons, no EN · NL (footer + menu drawer have it), smaller logo, margin 24px
   Safety net: if the menus get longer later (edited in the admin), measure and shrink further:
   icons, smaller logo, then a tighter left menu (--snug), and as a last resort the left menu
   moves into the hamburger drawer (--drawer), like on tablets. */
(function () {
  var header = document.querySelector('.section-header .header--middle-center');
  if (!header) return;
  var MIN_PAD = 24;
  var AIR = 40; // at least this much space between the menus and the logo
  var COMPACT = 'tfa-header--compact';
  var TIGHT = 'tfa-header--tight';
  var SNUG = 'tfa-header--snug';
  var DRAWER = 'tfa-header--drawer';

  function sideWidth(el) {
    if (!el) return 0;
    var gap = parseFloat(getComputedStyle(el).columnGap) || 0;
    var total = 0;
    var count = 0;
    Array.prototype.forEach.call(el.children, function (child) {
      var width = child.getBoundingClientRect().width;
      if (!width) return;
      var cs = getComputedStyle(child);
      total += width + (parseFloat(cs.marginLeft) || 0) + (parseFloat(cs.marginRight) || 0);
      count += 1;
    });
    return total + Math.max(0, count - 1) * gap;
  }

  // largest side margin at which both sides still fit next to the centred logo, with AIR to spare
  function room() {
    var nav = header.querySelector('.header__inline-menu .list-menu--inline');
    var icons = header.querySelector('.header__icons');
    // <h1 class="header__heading"> on the homepage, a bare logo link on every other page
    var logo = header.querySelector('.header__heading') || header.querySelector(':scope > .header__heading-link');
    var gap = Math.max(AIR, parseFloat(getComputedStyle(header).columnGap) || 0);
    var side = Math.max(sideWidth(nav), sideWidth(icons));
    var logoWidth = logo ? logo.getBoundingClientRect().width : 0;
    return Math.floor((header.getBoundingClientRect().width - logoWidth - 2 * gap - 2 * side) / 2);
  }

  function setPad(pad) {
    header.style.setProperty('--tfa-header-pad', Math.round(pad) + 'px');
  }

  var busy = false;
  function fit() {
    if (busy) return;
    busy = true;
    header.classList.remove(COMPACT, TIGHT, SNUG, DRAWER);
    header.style.removeProperty('--tfa-header-pad');
    if (window.matchMedia('(min-width: 990px)').matches) {
      var width = document.documentElement.clientWidth;
      var maxPad = width * 0.086;
      var pad;
      if (width >= 1460) {
        pad = (width - 1410) / 2;
      } else if (width >= 1238) {
        header.classList.add(COMPACT);
        pad = (width - 1190) / 2;
      } else {
        header.classList.add(COMPACT, TIGHT);
        pad = MIN_PAD;
      }
      pad = Math.max(MIN_PAD, Math.min(maxPad, pad));
      setPad(pad);
      // safety net for longer menus
      var max = room();
      if (max < pad) {
        if (max < MIN_PAD && !header.classList.contains(COMPACT)) {
          header.classList.add(COMPACT);
          max = room();
        }
        if (max < MIN_PAD && !header.classList.contains(TIGHT)) {
          header.classList.add(TIGHT);
          max = room();
        }
        if (max < MIN_PAD) {
          header.classList.add(SNUG);
          max = room();
        }
        if (max < MIN_PAD) {
          header.classList.add(DRAWER);
          max = room();
        }
        setPad(Math.max(MIN_PAD, Math.min(pad, max)));
      }
    }
    busy = false;
  }

  fit();
  window.addEventListener('resize', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  // cart count changes ("Winkelmand (1)") re-render part of the icons
  var icons = header.querySelector('.header__icons');
  if (icons && window.MutationObserver) {
    new MutationObserver(function () {
      window.requestAnimationFrame(fit);
    }).observe(icons, { childList: true, subtree: true, characterData: true });
  }
})();
